<template>
  <b-card class="mx-auto mt-2 mb-3">
    <div class="pa-3">
      <b-row>
        <b-col cols="10">
          <span style="font-size: 14px">{{ organizationLead.title }}</span>
        </b-col>
        <b-col cols="2" class="mb-0 pb-0">
          <b-dropdown
            ref="dropdownMenu"
            lazy
            class="float-right"
            size="xs" variant="link"
            right text="Right align"
            toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="fa fa-ellipsis-v fa-lg"></i>
            </template>
            <b-dropdown-item @click="show(organizationLead['@id'])"><i class="fa fa-eye mr-2"></i>{{$t('buttons.show')}}</b-dropdown-item>
            <b-dropdown-item @click="edit(organizationLead['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
            <b-dropdown-item @click="addNoteToOrganizationLeadModal(organizationLead['@id'])"><i class="fa fa-sticky-note mr-2"></i> {{$t('buttons.addNote')}}</b-dropdown-item>
            <b-dropdown-item @click="addPhoneToOrganizationLeadModal(organizationLead['@id'])"><i class="fa fa-phone mr-2"></i> {{$t('buttons.addPhoneNote')}}</b-dropdown-item>
            <b-dropdown-item @click="addMeetingToOrganizationLeadModal(organizationLead['@id'])"><i class="fa fa-calendar mr-2"></i> {{$t('buttons.addRelationNote')}}</b-dropdown-item>
            <b-dropdown-item @click="deleteSingle(organizationLead['@id'])"><i class="fa fa-trash mr-2"></i> {{$t('buttons.delete')}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-card-body class="mt-0 pb-0 pt-2 pl-1 ml-0">
        <b-row>
          <b-col cols="12" v-if="organizationLead.description">
            <span>{{organizationLead.description}}</span>
          </b-col>
        </b-row>
        <b-row v-if="organizationLead.tags && organizationLead.tags.length > 0">
          <b-col cols="12" v-for="(tag, index) in organizationLead.tags" :key="index">
            <b-badge class="mb-1 organizationleadtag" pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
          </b-col>
        </b-row>
      </b-card-body>
    </div>
  </b-card>
</template>

<script>
import remove from '@/utils/remove'
export default {
  name: 'organizationLeadCard',
  components: {
  },
  data () {
    return {
    }
  },
  props: {
    organizationLead: {
      type: Object,
      default: () => {}
    },
    fetchData: {
      type: Function,
      default: () => {}
    },
    addNoteToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    },
    addPhoneToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    },
    addMeetingToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  methods: {
    show (id) {
      this.$router.push({ name: 'EXABOrganizationLeadShow', params: { id: id } })
    },
    edit (id) {
      this.$router.push({ name: 'EXABOrganizationLeadUpdate', params: { id: id } })
    },
    deleteSingle (id) {
      remove(id, () => {
        this.fetchData()
      })
    }
  }
}
</script>
